import { SavedListingTabConfig } from 'listing-details/components/SavedListingsTabs/SavedListingsTabs.types';

export const sections: Array<SavedListingTabConfig> = [
    {
        key: 'for-sale',
        label: 'For sale'
    },
    {
        key: 'to-rent',
        label: 'To rent'
    },
    {
        key: 'overseas',
        label: 'Overseas'
    },
    {
        key: 'commercial',
        label: 'Commercial'
    }
];
